<script>
export default {};
</script>
<template>

    <svg
      width="200px"
      height="72px"
      viewBox="0 0 200 72"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>Button 2</title>
      <defs>
        <linearGradient
          x1="61.0177504%"
          y1="4.97437972%"
          x2="26.4677513%"
          y2="71.8702805%"
          id="linearGradient-1"
        >
          <stop stop-color="#00A0FF" offset="0%"></stop>
          <stop stop-color="#00A1FF" offset="0.7%"></stop>
          <stop stop-color="#00BEFF" offset="26%"></stop>
          <stop stop-color="#00D2FF" offset="51.2%"></stop>
          <stop stop-color="#00DFFF" offset="76%"></stop>
          <stop stop-color="#00E3FF" offset="100%"></stop>
        </linearGradient>
        <linearGradient
          x1="107.593617%"
          y1="49.9589387%"
          x2="-130.516888%"
          y2="49.9589387%"
          id="linearGradient-2"
        >
          <stop stop-color="#FFE000" offset="0%"></stop>
          <stop stop-color="#FFBD00" offset="40.9%"></stop>
          <stop stop-color="#FFA500" offset="77.5%"></stop>
          <stop stop-color="#FF9C00" offset="100%"></stop>
        </linearGradient>
        <linearGradient
          x1="86.257166%"
          y1="30.8819044%"
          x2="-50.1998381%"
          y2="135.957932%"
          id="linearGradient-3"
        >
          <stop stop-color="#FF3A44" offset="0%"></stop>
          <stop stop-color="#C31162" offset="100%"></stop>
        </linearGradient>
        <linearGradient
          x1="-18.8220243%"
          y1="-11.8615321%"
          x2="42.1093117%"
          y2="34.9867102%"
          id="linearGradient-4"
        >
          <stop stop-color="#32A071" offset="0%"></stop>
          <stop stop-color="#2DA771" offset="6.9%"></stop>
          <stop stop-color="#15CF74" offset="47.6%"></stop>
          <stop stop-color="#06E775" offset="80.1%"></stop>
          <stop stop-color="#00F076" offset="100%"></stop>
        </linearGradient>
      </defs>
      <g
        id="Web"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g
          id="Web-Learn-&amp;-Play-Game"
          transform="translate(-810.000000, -1509.000000)"
        >
          <g id="Devices" transform="translate(440.000000, 840.000000)">
            <g id="Buttons" transform="translate(150.000000, 669.000000)">
              <g id="Button-2" transform="translate(220.000000, 0.000000)">
                <rect
                  id="Rectangle"
                  fill="#231F20"
                  x="0"
                  y="0"
                  width="200"
                  height="72"
                  rx="14"
                ></rect>
                <g id="Google_Play" transform="translate(25.000000, 22.000000)">
                  <path
                    d="M0.494031414,0.428062827 C0.180314136,0.765235602 0,1.28418848 0,1.95853403 L0,25.944712 C0,26.6190576 0.180314136,27.1380105 0.505759162,27.4634555 L0.59078534,27.535288 L14.0307853,14.095288 L14.0307853,13.7932984 L0.579057592,0.356230366 L0.494031414,0.428062827 Z"
                    id="Path"
                    fill="url(#linearGradient-1)"
                  ></path>
                  <path
                    d="M18.5019895,18.5928796 L14.0190576,14.1084817 L14.0190576,13.7947644 L18.5034555,9.31036649 L18.6002094,9.3704712 L23.9040838,12.3845026 C25.4228272,13.2406283 25.4228272,14.6508901 23.9040838,15.5187435 L18.6002094,18.5327749 C18.5987435,18.5327749 18.5019895,18.5928796 18.5019895,18.5928796 L18.5019895,18.5928796 Z"
                    id="Path"
                    fill="url(#linearGradient-2)"
                  ></path>
                  <path
                    d="M18.5987435,18.5327749 L14.0190576,13.951623 L0.494031414,27.4766492 C0.988062827,28.0073298 1.81926702,28.0674346 2.7486911,27.5484817 L18.5987435,18.5327749"
                    id="Path"
                    fill="url(#linearGradient-3)"
                  ></path>
                  <path
                    d="M18.5987435,9.37193717 L2.7486911,0.367958115 C1.82073298,-0.162722513 0.988062827,-0.0908900524 0.494031414,0.439790576 L14.0175916,13.951623 L18.5987435,9.37193717 Z"
                    id="Path"
                    fill="url(#linearGradient-4)"
                  ></path>
                  <path
                    d="M18.5019895,18.4360209 L2.76041885,27.3798953 C1.8808377,27.8856545 1.0965445,27.8504712 0.59078534,27.391623 L0.505759162,27.4766492 L0.59078534,27.5484817 C1.0965445,28.0058639 1.8808377,28.0425131 2.76041885,27.5367539 L18.6104712,18.5327749 L18.5019895,18.4360209 L18.5019895,18.4360209 Z"
                    id="Path"
                    fill="#000000"
                    fill-rule="nonzero"
                    opacity="0.2"
                  ></path>
                  <path
                    d="M23.9026178,15.3618848 L18.4902618,18.4360209 L18.5870157,18.5327749 L23.8908901,15.5187435 C24.6502618,15.0848168 25.0240838,14.5189529 25.0240838,13.951623 C24.9757068,14.4705759 24.5901571,14.9646073 23.9026178,15.3618848 L23.9026178,15.3618848 Z"
                    id="Path"
                    fill="#000000"
                    fill-rule="nonzero"
                    opacity="0.12"
                  ></path>
                  <path
                    d="M2.7486911,0.524816754 L23.9026178,12.5428272 C24.5901571,12.928377 24.9757068,13.4341361 25.0358115,13.953089 C25.0358115,13.3872251 24.6619895,12.8198953 23.9026178,12.3859686 L2.7486911,0.367958115 C1.22994764,-0.499895288 0,0.222827225 0,1.95853403 L0,2.11539267 C0,0.379685864 1.22994764,-0.331308901 2.7486911,0.524816754 Z"
                    id="Path"
                    fill="#FFFFFF"
                    opacity="0.25"
                  ></path>
                </g>
                <text
                  id="Google-Play"
                  font-family="Stag-Sans-Round-Bold"
                  font-size="20"
                  font-weight="bold"
                  letter-spacing="0.2"
                  fill="#FFFFFF"
                >
                  <tspan x="65" y="52">Google Play</tspan>
                </text>
                <text
                  id="Get-it-on"
                  font-family="Stag-Sans-Round-Book"
                  font-size="14"
                  font-weight="300"
                  letter-spacing="0.2"
                  fill="#FFFFFF"
                >
                  <tspan x="65" y="29">Get it on</tspan>
                </text>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>

</template>
